import { safetyTips } from '@/mocks/faq';

export default function SafetyTips() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            安全防护小贴士
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            简单实用的安全建议，让每次上网都多一层保护
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.id}
              className="flex items-start gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70"
            >
              <div className="w-10 h-10 flex items-center justify-center shrink-0 rounded-lg bg-accent-100/80 text-accent-700">
                <i className={`${tip.icon} text-lg`}></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1 font-heading">
                  {tip.title}
                </h4>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {tip.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}